import React, { useState, useEffect } from 'react';
import { Map, ZoomControl, Marker } from 'pigeon-maps';
import { osm } from 'pigeon-maps/providers';
import styles from './WorkersMaps.module.scss';
import JurisdictionCoordinates from './JurisdictionCoordinates';
import MapsLoading from '../Loading/MapLoading';
import { connect } from 'react-redux';
import { openSuscriptionModal } from '../../../store/actions';

const WorkersMaps = ({
    ciudadesArray,
    setSelectedUser,
    setIsFiltered,
    isFiltered,
    setLoading,
    setCoordinatesArray,
    setZoom,
    setCenter,
    loading,
    openSuscriptionModal,
    coordinatesArray,
    isUserPremium,
    zoom,
    center,
}) => {

    const [hoveredMarker, setHoveredMarker] = useState(null);

    const handleSearch = async () => {
        try {
            const results = ciudadesArray.flatMap((cityObj) =>
                cityObj.jobBoardZones.map((zone) => {
                    let city = zone.jurisdiccion?.name;

                    const coordinates = JurisdictionCoordinates[city];
                    if (coordinates) {
                        return {
                            city: zone.city,
                            coordinates: [coordinates.lat, coordinates.lon],
                            userInfo: cityObj
                        };
                    }
                    return null;
                })
            ).filter(Boolean);
            setCoordinatesArray(results);
        } catch (error) {
            console.error('Error al procesar la solicitud:', error);
        }
    };

    useEffect(() => {
        handleSearch();
    }, [ciudadesArray]);

    useEffect(() => {
        if (isFiltered) {
            setZoom(6);
            setCenter(coordinatesArray[0]?.coordinates);
        }
    }, [coordinatesArray]);

    const handleMarkerClick = (index) => {
        const location = coordinatesArray[index];
        const usersAtLocation = coordinatesArray.filter(
            (coord) =>
                coord.coordinates[0] === location.coordinates[0] &&
                coord.coordinates[1] === location.coordinates[1]
        );
        setSelectedUser(usersAtLocation.map((user) => user.userInfo));
        setHoveredMarker(index);
        setCenter(location.coordinates);
        setZoom(7);
        setIsFiltered(false);
    };

    const renderMarker = (location, index) => {
        return (
            <Marker
                key={index}
                width={30}
                anchor={location.coordinates}
                color="red"
                onMouseOver={() => setHoveredMarker(index)}
                onMouseOut={() => setHoveredMarker(null)}
                onClick={() => {
                    if (isUserPremium) {
                        handleMarkerClick(index, location.coordinates);
                    } else {
                        openSuscriptionModal();
                    }
                }}
            >
            </Marker>
        );
    };

    const renderInfoBox = (index) => {
        if (hoveredMarker !== index) return null;

        const location = coordinatesArray[index];

        const markersAtLocation = coordinatesArray.filter((coord) =>
            coord.coordinates[0] === location.coordinates[0] &&
            coord.coordinates[1] === location.coordinates[1]
        );

        const count = markersAtLocation.length;

        return (
            <div
                key={`info-${index}`}
                className={styles.info}
            >
                <h3 className={styles.info_header}>Tenemos {count} {count > 1 ? "trabajdores" : "trabajador"} en {location.jurisdiccion?.name}</h3>
                <p>Click para ver el detalle</p>
            </div>
        );
    };

    return (
        <div className={styles.workerMapContainer}>
            <div className={styles.workerMapContainer_map}>
                {loading && <MapsLoading />}
                <Map
                    provider={osm}
                    center={center}
                    zoom={zoom}
                >
                    {coordinatesArray.map((location, index) =>
                        renderMarker(location, index)
                    )}
                    <ZoomControl style={{top: "85%"}} />
                </Map>
                {coordinatesArray.map((location, index) =>
                    renderInfoBox(index, location.coordinates)
                )}
            </div>
        </div>
    );
};

const mapStateToProps = (state) => {
    return {
        isUserPremium: state.general.isUserPremium,
    };
};

export default connect(mapStateToProps, { openSuscriptionModal })(WorkersMaps);




